// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"_2uv0H","icon":"_2uRJ6","title":"_1K4bg","content":"_3m4cu"};